import React from "react";

import "./ProgressBarCustom.scss";

export const ProgressBarCustom = (props) => {
    const { completed, labelLeft, labelRight, labelCenter, isLabelVisible } = props;
  
    const labelStyles = {
      padding: 5,
      color: "white",
      fontWeight: "bold",
    };

    return (
      <div className='custom-progress-container'>
        <div className='custom-progress' style={{width: `${completed}%`}}>
        </div>
        {isLabelVisible && <div className="custom-label-container">
          {labelLeft && <span className='custom-label-left'>{labelLeft}</span>}
          <span className='custom-label-center'>{`${completed}%`}</span>
          {labelRight && <span className='custom-label-right'>{labelRight}</span>}
        </div>}
      </div>
    );
  };